import * as Joi from 'joi';
import _ from 'lodash';
import { AnswerColumnPropVersion } from '../types/prism';
import { AnswerColumnPropV1Schema } from './types/v1';
import { upgraderFn as upgradeV0ToV1 } from './upgraders/v0-to-v1';
const LATEST_CLIENT_STATE_SCHEMA = AnswerColumnPropV1Schema;
const clientStateUpgradeChain = {
    null: {
        returnVersion: AnswerColumnPropVersion.V1,
        upgraderFn: upgradeV0ToV1,
    },
};
function upgradeClientStateToLatestVersion(vizModel) {
    let clientState = vizModel.vizProps;
    let clientStateVersion = !_.isNil(clientState) && !_.isNil(clientState.version)
        ? clientState.version
        : null;
    let currVersionUpgradeArc = clientStateUpgradeChain[clientStateVersion];
    while (!_.isNil(currVersionUpgradeArc) &&
        !_.isNil(currVersionUpgradeArc.upgraderFn)) {
        clientState = currVersionUpgradeArc.upgraderFn(clientState, vizModel);
        clientStateVersion = currVersionUpgradeArc.returnVersion || undefined;
        currVersionUpgradeArc = clientStateUpgradeChain[clientStateVersion];
    }
    Joi.assert(clientState, LATEST_CLIENT_STATE_SCHEMA);
    return clientState;
}
export { upgradeClientStateToLatestVersion };
//# sourceMappingURL=upgrader.js.map